import React, { useState } from "react";
import { Box, Typography, Grid, Paper, Button, Stack, alpha, keyframes } from "@mui/material";
import SectionContainer from "../ui/SectionContainer";
import { useLanguage } from "../../i18n/LanguageContext";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const Service = ({ hideHeader = false }) => {
  const { t } = useLanguage();

  // nombre de services visibles
  const [visibleCount, setVisibleCount] = useState(2);

  const ServicesData = [
    {
      id: 1,
      name: t("services.CRM"),//"24-CRM",
      title: t("services.Gestion_Cloud"),//"Gestion Commerciale Cloud",
      desc: t("services.crm_desc"),
      cover: "./images/dd.png",
      source: "https://24-crm.tn/",
      accent: "#2196F3",
    },
    {
      id: 2,
      name: t("services.Paie"),//"24-Paie",
      title: t("services.Gestion_Paie"),//,"Gestion Sociale & Paie",
      desc: t("services.paie_desc"),
      cover: "./images/24paiec.png",
      source: "#",
      accent: "#4CAF50",
    },
    {
      id: 3,
      name: t("services.Gold"),//"24-Gold",
      title: t("services.Bijouterie"),//"Logiciel Bijouterie & Orfèvrerie",
      desc: t("services.gold_desc"),
      cover: "./images/goldd.png",
      source: "#",
      accent: "#FFD700",
    },
    {
      id: 4,
      name: "Custom Dev",
      title: t("services.Sur_Mesure"),//"Développement Sur-Mesure",
      desc: t("services.dev_desc"),
      cover: "./images/serv4.jpg",
      source: "#",
      accent: "#DD8748",
    },
    {
      id: 5,
      name: "IT Consulting",
      title: t("services.Transformation"),//"Audit & Transformation Digitale",
      desc: t("services.consulting_desc"),
      cover: "./images/serv5.jpg",
      source: "#",
      accent: "#1D2558",
    },
    {
      id: 6,
      name: "E-commerce",
      title: t("services.fasty"),//"E-commerce Synchronisé",
      desc: t("services.fasty_desc"),
      cover: "./images/ecomm.png",
      source: "http://www.24-crm.online",
      accent: "#e91e63",
    },
    {
      id: 7,
      name:"PolyPointage",
      title: t("services.PolyPointage"),//"PolyPointage",//
      desc: t("services.pointage_desc"),
      cover: "./images/pointage.png",
      source: "",
      accent: "#0dc5f1",
    },
    {
    id: 8,
    name:"GenRS",
    title: t("services.GenRS"),//Génération retenue à la source (independant/synchronisée)",
    desc: t("services.GenRS_desc"),
    cover: "./images/RS.png",
    source: "",
    accent: "#8a6dbf",
  },
  ];

  return (
    <SectionContainer bgColor="transparent" py={12}>
      {!hideHeader && (
        <Box textAlign="center" mb={12}>
          <Typography
            variant="overline"
            sx={{ color: "#DD8748", fontWeight: 900, letterSpacing: 4 ,mb: 2, fontSize: '1.3rem'}}
          >
            {t("services.title")}
          </Typography>

          <Typography
            variant="h2"
            sx={{ fontWeight: 950, color: "#1D2558", mt: 1 }}
          >
            {t("services.subtitle")}
          </Typography>
        </Box>
      )}

      <Grid container spacing={6}>
        {ServicesData.slice(0, visibleCount).map((val) => (
          <Grid item xs={12} md={6} key={val.id}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 8,
                overflow: "hidden",
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.04)",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                transition: "all 0.4s",
                "&:hover": {
                  transform: "scale(1.02)",
                  boxShadow: "0 40px 80px rgba(6,57,125,0.08)",
                  borderColor: alpha(val.accent, 0.2),
                },
              }}
            >
              {/* Image */}
              <Box
                sx={{
                  width: { xs: "100%", sm: "40%" },
                  position: "relative",
                  overflow: "hidden",
                  bgcolor: alpha(val.accent, 0.05),
                }}
              >
                <Box
                  component="img"
                  src={val.cover}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    p: 3,
                    animation: `${float} 4s ease-in-out infinite`,
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 4,
                    height: "100%",
                    bgcolor: val.accent,
                  }}
                />
              </Box>

              {/* Content */}
              <Box sx={{ p: 5, flex: 1, display: "flex", flexDirection: "column" }}>
                <Stack direction="row" spacing={1} mb={1}>
                  <Typography
                    variant="overline"
                    sx={{
                      color: val.accent,
                      fontWeight: 900,
                      letterSpacing: 1.5,
                    }}
                  >
                    {val.name}
                  </Typography>
                </Stack>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 900,
                    color: "#1D2558",
                    mb: 2,
                  }}
                >
                  {val.title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    lineHeight: 1.7,
                    mb: 4,
                    flexGrow: 1,
                  }}
                >
                  {val.desc}
                </Typography>

                <Button
                  variant="outlined"
                  href={val.source}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    borderRadius: 3,
                    py: 1.5,
                    px: 4,
                    borderColor: alpha(val.accent, 0.3),
                    color: val.accent,
                    fontWeight: 800,
                    alignSelf: "flex-start",
                    textTransform: "none",
                  }}
                >
                 {t("services.Exploration")} {/* Exploration Solution */}
                </Button>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Buttons */}
      <Box textAlign="center" mt={8}>
        {visibleCount < ServicesData.length && (
          <Button
            variant="contained"
            onClick={() => setVisibleCount(ServicesData.length)}
            sx={{
              px: 6,
              py: 1.5,
              borderRadius: 5,
              fontWeight: 800,
              background: "#1D2558",
              mr: 2,
            }}
          >
            {t("services.more")}{/* Voir plus */}
          </Button>
        )}

        {visibleCount === ServicesData.length && (
          <Button
            variant="outlined"
            onClick={() => setVisibleCount(2)}
            sx={{
              px: 6,
              py: 1.5,
              borderRadius: 5,
              fontWeight: 800,
              borderColor: "#1D2558",
              color: "#1D2558",
            }}
          >
           {t("services.less")} {/* Voir moins */}
          </Button>
        )}
      </Box>
    </SectionContainer>
  );
};

export default Service;










// import React from "react";
// import { Box, Typography, Grid, Paper, Button, Stack, alpha, keyframes } from '@mui/material';
// import SectionContainer from "../ui/SectionContainer";
// import { useLanguage } from "../../i18n/LanguageContext";
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// const float = keyframes`
//   0%, 100% { transform: translateY(0); }
//   50% { transform: translateY(-10px); }
// `;

// const Service = ({ hideHeader = false }) => {
//   const { t } = useLanguage();

//   const ServicesData = [
//     {
//       id: 1,
//       name: "24-CRM",
//       title: "Gestion Commerciale Cloud",
//       desc: t('services.crm_desc'),
//       cover: "./images/dd.png",
//       source: "https://24-crm.com/",
//       accent: "#2196F3"
//     },
//     {
//       id: 2,
//       name: "24-Paie",
//       title: "Gestion Sociale & Paie",
//       desc: t('services.paie_desc'),
//       cover: "./images/24paiec.png",
//       source: "#",
//       accent: "#4CAF50"
//     },
//     {
//       id: 3,
//       name: "24-Gold",
//       title: "Logiciel Bijouterie & Orfèvrerie",
//       desc: t('services.gold_desc'),
//       cover: "./images/goldd.png",
//       source: "#",
//       accent: "#FFD700"
//     },
//     {
//       id: 4,
//       name: "Custom Dev",
//       title: "Développement Sur-Mesure",
//       desc: t('services.dev_desc'),
//       cover: "./images/serv4.jpg",
//       source: "#",
//       accent: "#DD8748"
//     },
//     {
//       id: 5,
//       name: "IT Consulting",
//       title: "Audit & Transformation Digitale",
//       desc: t('services.consulting_desc'),
//       cover: "./images/serv5.jpg",
//       source: "#",
//       accent: "#1D2558"
//     },
//     {
//       id: 6,
//       name: "Fasty-com",
//       title: "E-commerce Synchronisé",
//       desc: t('services.fasty_desc'),
//       cover: "./images/ecomm.png",
//       source: "http://www.24-crm.online",
//       accent: "#e91e63"
//     },
//   ];

//   return (
//     <SectionContainer bgColor="transparent" py={12}>
//       {!hideHeader && (
//         <Box textAlign="center" mb={12} data-aos="fade-up">
//           <Typography
//             variant="overline"
//             sx={{ color: '#DD8748', fontWeight: 900, letterSpacing: 4 }}
//           >
//             {t('services.title')}
//           </Typography>
//           <Typography
//             variant="h2"
//             sx={{ fontWeight: 950, color: '#1D2558', mt: 1, letterSpacing: -1 }}
//           >
//             {t('services.subtitle')}
//           </Typography>
//         </Box>
//       )}

//       <Grid container spacing={6}>
//         {ServicesData.map((val) => (
//           <Grid item xs={12} md={6} key={val.id} data-aos="fade-up" data-aos-delay={val.id * 50}>
//             <Paper
//               elevation={0}
//               sx={{
//                 borderRadius: 8,
//                 overflow: 'hidden',
//                 background: '#fff',
//                 border: '1px solid rgba(0,0,0,0.04)',
//                 display: 'flex',
//                 flexDirection: { xs: 'column', sm: 'row' },
//                 transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//                 '&:hover': {
//                   transform: 'scale(1.02)',
//                   boxShadow: '0 40px 80px rgba(6, 57, 125, 0.08)',
//                   borderColor: alpha(val.accent, 0.2),
//                   '& .serv-img': { transform: 'scale(1.1)' },
//                   '& .serv-btn': { bgcolor: val.accent, color: '#fff', borderColor: val.accent }
//                 }
//               }}
//             >
//               {/* Image Container with Animation */}
//               <Box
//                 sx={{
//                   width: { xs: '100%', sm: '40%' },
//                   position: 'relative',
//                   overflow: 'hidden',
//                   bgcolor: alpha(val.accent, 0.05)
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={val.cover}
//                   className="serv-img"
//                   sx={{
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'contain',
//                     p: 3,
//                     transition: 'transform 0.6s ease',
//                     animation: `${float} 4s ease-in-out infinite`
//                   }}
//                 />
//                 <Box sx={{ position: 'absolute', top: 0, left: 0, width: 4, height: '100%', bgcolor: val.accent }} />
//               </Box>

//               {/* Content Area */}
//               <Box sx={{ p: 5, flex: 1, display: 'flex', flexDirection: 'column' }}>
//                 <Stack direction="row" alignItems="center" spacing={1} mb={1}>
//                   <Typography variant="overline" sx={{ color: val.accent, fontWeight: 900, letterSpacing: 1.5 }}>
//                     {val.name}
//                   </Typography>
//                 </Stack>

//                 <Typography variant="h5" sx={{ fontWeight: 900, color: '#1D2558', mb: 2, lineHeight: 1.2 }}>
//                   {val.title}
//                 </Typography>

//                 <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7, mb: 4, flexGrow: 1 }}>
//                   {val.desc}
//                 </Typography>

//                 <Button
//                   variant="outlined"
//                   className="serv-btn"
//                   endIcon={<ArrowForwardIcon />}
//                   sx={{
//                     borderRadius: 3,
//                     py: 1.5,
//                     px: 4,
//                     borderColor: alpha(val.accent, 0.3),
//                     color: val.accent,
//                     fontWeight: 800,
//                     alignSelf: 'flex-start',
//                     transition: 'all 0.3s ease',
//                     textTransform: 'none'
//                   }}
//                 >
//                   Exploration Solution
//                 </Button>
//               </Box>
//             </Paper>
//           </Grid>
//         ))}
//       </Grid>
//     </SectionContainer>
//   );
// };

// export default Service;